// extracted by mini-css-extract-plugin
export default {"button":"BackToTop_button__mYvcY","show":"BackToTop_show__kVF8O","icon":"BackToTop_icon__jsfc6"};